import request from "@/utils/request";

export async function change(locale) {
  return await request.post(`/locale/change`, {
    locale,
  });
}
